import * as zod from 'zod';

export const ControlPanelTokenData = zod.object({
  accessToken: zod.string(),
  pin: zod.string(),
});

export type ControlPanelTokenData = zod.infer<typeof ControlPanelTokenData>;
